/* eslint-disable react-hooks/exhaustive-deps */
import {
  getOrganizationChilds,
  getTiledOrganizationByKeyword,
  searchOrganizationTree,
} from "api/order"
import LeftArrow from "icons/black.svg"
import SearchIcon from "icons/search.svg"
import CheckBox from "icons/weixuanze.svg"
import CheckBoxSelected from "icons/xuanze.svg"
import immer from "immer"
import { debounce } from "rambdax"
import { Fragment, useEffect, useRef, useState } from "react"
import { Icon, Popup, Search } from "react-vant"
import { SearchProps } from "react-vant/es/search"
import { cls } from "reactutils"
import Button from "./Button"

const PopupStyle = {
  width: "100%",
  height: "100%",
}

export default function DrawerTree({
  placeholder = "请选择",
  value = {},
  onClickSearchIcon = () => {},
  title,
  change,
  name = "name",
  visible,
  onClose,
  params: searchParams = {},
  ...props
}: SearchProps & {
  value?: any
  title?: string
  change: Function
  name?: string
  visible: boolean
  onClose: () => void
  params?: any
  onClickSearchIcon?: () => void
}) {
  const [list, setList] = useState([])
  const [currentList, setCurrentList] = useState([])
  const [currentSelect, setCurrentSelect] = useState<any>({})
  const [options, setOptions] = useState([])
  const params = useRef({
    keyword: "",
    parentOrganizationCodeList: [],
    organizationType: 1,
    includeVirtualOrganization: false,
    tenantSysNo: null,
    notIsolated: false,
    purchaserAuditStatus: null,
    pageSize: 500,
    pageNo: 1,
  })
  const [searchName, setSearchName] = useState("")
  const [path, setPath] = useState([])
  const [showAction, setShowAction] = useState(false)
  const loading = useRef(false)
  // const totalPage = useRef(0)
  const searchList = useRef<any>()
  const clear = () => {}

  const onChange = (e) => {
    setSearchName(e)
    debounce(() => {
      onSearch(e)
    }, 300)
  }

  const onSearch = (e) => {
    setShowAction(true)
    params.current.keyword = e
    params.current.pageNo = 1
    fetchData(true)
  }

  const fetchData = async (init?: boolean) => {
    if (!loading.current) {
      loading.current = true
      const res = await getTiledOrganizationByKeyword(params.current)
      // totalPage.current = res.data.totalPage
      const arr = init ? res.data : [...list, ...res.data]
      setList(arr)
      setTimeout(() => {
        loading.current = false
      }, 100)
    }
  }

  const dfs = (arr, val, data) => {
    for (let v of arr) {
      if (v.organizationCode === val.organizationCode) {
        v.children = data
      }
      if (v.children) {
        dfs(v.children, val.organizationCode, data)
      }
    }
  }

  const handlePath = (v) => {
    const index = path.findIndex(
      (c) => c.organizationCode === v.organizationCode,
    )
    if (index !== -1) {
      setPath(path.slice(0, index + 1))
    } else {
      setPath([...path, v])
    }
  }

  const updateTree = (v, data) => {
    const newOptions = immer(options, (draft) => {
      dfs(draft, v, data)
    })
    setOptions(newOptions)
    setCurrentList(data)
    handlePath(v)
  }

  const choose = async (e) => {
    if (e.childrenCount > 0 || e.childCount > 0) {
      const res = await getOrganizationChilds({
        parentOrganizationCode: e.organizationCode,
        limieRoleTypes: e.organizationCode==='0001' ? [10]: [],
        authKeys: ["TENDER_PURCHASER_ORDER_DELIVERY_LIST"],
        organizationType: 1,
        includeVirtualOrganization: false,
        notIsolated: false,
        selectTenantSysNo: null,
        onlySearchPurchaser: false,
        purchaserAuditStatus: null,
        pageSize: 500,
        pageNo: 1,
        ...searchParams,
      })
      updateTree(e, res.data)
    }
  }

  const searchOrg = async () => {
    const res = await searchOrganizationTree({
      authKeys: ["TENDER_PURCHASER_ORDER_DELIVERY_LIST"],
      notIsolated: false,
      onlySearchPurchaser: false,
      organizationType: 1,
      purchaserAuditStatus: null,
      selectTenantSysNo: null,
      ...searchParams,
    })
    setOptions(res.data)
    setCurrentList(res.data)
    res.data.forEach((v) => {
      params.current.parentOrganizationCodeList.push(v.organizationCode)
    })
  }

  const scrollFn = (e) => {
    if (
      e.target.scrollTop + e.target.offsetHeight >=
      e.target.scrollHeight - 100
    ) {
      if (!loading.current) {
        params.current.pageNo++
        fetchData()
      }
    }
  }

  useEffect(() => {
    searchOrg()
  }, [])

  useEffect(() => {
    if (showAction) {
      searchList.current.addEventListener("scroll", scrollFn)
    }
    return () => {
      if (searchList.current) {
        searchList.current.removeEventListener("scroll", scrollFn)
      }
    }
  }, [showAction, list])

  useEffect(() => {
    setCurrentSelect(value)
  }, [value])

  const select = (e) => {
    choose(e)
    setCurrentSelect(e)
  }

  const reset = () => {
    setCurrentSelect({})
    setCurrentList(options)
    setPath([])
  }

  const cancel = () => {
    setShowAction(false)
  }

  const confirm = () => {
    change(currentSelect)
    onClose()
  }

  return (
    <>
      <div className="itemWrap">
        <Popup
          visible={visible}
          position="right"
          style={PopupStyle}
          onClose={() => onClose()}
          transition="simple-right-transition"
        >
          <div className="close-box">
            <Icon name="cross" onClick={onClose} />
          </div>
          <div className="custom-search">
            <Search
              value={searchName}
              leftIcon={null}
              rightIcon={
                <span className="icon-box" onClick={onClickSearchIcon}>
                  <SearchIcon />
                </span>
              }
              onChange={onChange}
              onSearch={onSearch}
              onClear={clear}
              placeholder={placeholder}
              showAction={showAction}
              onCancel={cancel}
              {...props}
            />
          </div>
          {!showAction && (
            <div className="list-item">
              <span onClick={reset}>组织</span>
              {path?.map((v, i) => (
                <Fragment key={i}>
                  <span className="arrow">
                    <LeftArrow />
                  </span>
                  <span
                    className={cls(
                      currentSelect?.organizationCode === v.organizationCode &&
                        "active",
                    )}
                    onClick={() => select(v)}
                  >
                    {v.organizationName}
                  </span>
                </Fragment>
              ))}
            </div>
          )}

          {showAction ? (
            <div className="search-list" ref={searchList}>
              {list?.length > 0 ? (
                list.map((v, i) => (
                  <div
                    key={i}
                    className={cls(
                      "search-item",
                      currentSelect?.organizationCode === v.organizationCode &&
                        "active",
                    )}
                    onClick={() => setCurrentSelect(v)}
                  >
                    <div>
                      {currentSelect?.organizationCode ===
                      v.organizationCode ? (
                        <CheckBoxSelected />
                      ) : (
                        <CheckBox />
                      )}
                    </div>
                    <div className="name-box">
                      <div className="cur-org">{v.organizationName}</div>
                      <div className="cur-path">
                        {v.parentNameList?.join("/")}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="nodata">无数据</div>
              )}
            </div>
          ) : (
            <div className="tree-list">
              {currentList?.map((v, i) => (
                <div key={i} className="list-item">
                  <span
                    className="radio-box"
                    onClick={() => setCurrentSelect(v)}
                  >
                    {currentSelect?.organizationCode === v.organizationCode ? (
                      <CheckBoxSelected />
                    ) : (
                      <CheckBox />
                    )}
                  </span>
                  <span
                    className={cls(
                      currentSelect?.organizationCode === v.organizationCode &&
                        "active",
                    )}
                    onClick={() => setCurrentSelect(v)}
                  >
                    {v.organizationName}
                  </span>
                  {(v.childrenCount > 0 || v.childCount > 0) && (
                    <span onClick={() => choose(v)} className="list-svg">
                      <LeftArrow />
                    </span>
                  )}
                </div>
              ))}
            </div>
          )}
          <div className="bottom-btn">
            <Button text="确定" type="primary" onClick={confirm}></Button>
          </div>
        </Popup>
      </div>
      <style jsx>{`
        .custom-search {
          background-color: #fff;
          border: 1px solid #f1f1f1;
          border-radius: 0 0 3px 3px;
        }
        .text-panel {
          background: #f2f2f2;
          border-radius: 3px;
          display: flex;
          justify-content: space-between;
          padding: 13px 16px;
        }
        .itemWrap {
          padding: 10px 20px 17px 20px;
          border-bottom: 2px solid #f9f9f9;
        }
        .itemWrap:last-child {
          border-bottom: none;
        }

        .itemTitle {
          font-size: 15px;
          color: #262626;
          line-height: 13px;
          font-weight: bold;
          margin-bottom: 17px;
        }
        .back-box {
          display: flex;
          align-items: center;
          width: 20px;
          justify-content: flex-end;
        }
        .back-box :global(svg) {
          height: 14px;
        }
        .icon-box :global(svg) {
          transform: translateY(2px);
        }
        .custom-search :global(.rv-search__content) {
          align-items: center;
          height: 40px;
          background: #f2f2f2;
          border-radius: 3px;
        }
        .custom-search :global(.rv-search) {
          flex: 1;
        }
        .text-panel :global(svg) {
          transform: translate(2px, 4px) rotate(-90deg);
        }
        .open-pop :global(svg) {
          transform: translate(2px, 4px) rotate(90deg);
        }
        .tree-list {
          padding: 0 10px;
          height: calc(100vh - 225px);
          overflow: scroll;
        }
        .search-list {
          max-height: 200px;
          overflow: hidden;
          overflow-y: auto;
        }
        .list-item {
          height: 40px;
          line-height: 40px;
          padding: 0 13px;
          font-size: 14px;
          color: #333333;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          position: relative;
          border-bottom: 1px solid #f7f7f7;
        }
        .active {
          color: var(--primaryColor);
        }
        .nodata {
          font-size: 14px;
          color: #333333;
          text-align: center;
          padding-top: 10px;
          padding-bottom: 20px;
        }

        .close-box {
          display: flex;
          justify-content: flex-end;
          height: 40px;
          align-items: center;
          padding-right: 12px;
        }

        .list-svg :global(svg) {
          position: absolute;
          right: 10px;
          top: 15px;
          transform: rotate(180deg) scale(0.9) translateY(-1px);
        }
        .list-item :global(svg) {
          transform: rotate(180deg) scale(0.9) translateY(-1px);
        }
        .arrow {
          display: inline-block;
          margin: 0 10px;
        }
        .radio-box {
          display: inline-block;
          margin-right: 5px;
        }
        .radio-box :global(svg) {
          transform: translateY(3px) scale(0.9);
        }
        .search-item {
          height: 80px;
          padding: 0 13px;
          font-size: 14px;
          color: #333333;
          display: flex;
          border-bottom: 1px solid #f7f7f7;
          align-items: center;
        }
        .name-box {
          display: flex;
          justify-content: center;
          flex-direction: column;
          margin-left: 8px;
        }
        .cur-org {
          font-size: 15px;
          color: #333333;
          font-weight: bold;
        }
        .cur-path {
          font-size: 14px;
          color: #999999;
        }
        .bottom-btn {
          position: fixed;
          bottom: 0;
          left: 0;
          z-index: 99;
          width: 100vw;
          height: 83px;
          padding: 10px 16px;
          padding-bottom: 0;
          background: rgba(255, 255, 255, 0.94);
          box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
        }
      `}</style>
    </>
  )
}
